<template>
  <image
    class="seat"
    :class="extraClasses"
    :alt="altText"
    :href="seatIcon"
    :y="seatYCoord"
    :x="seatXCoord"
    :width="seatWidth"
    :height="seatHeight"
    :tabindex="1"
    :data-selected="isSelected"
    @keyup.enter="selectSeat"
    v-touch:tap="selectSeat"
  />
</template>

<script>
import _ from 'lodash';

export default {
  name: "seat-item",
  props: {
    seatInfo: {
      type: Object,
      required: true,
    },
    available: {
      type: Boolean,
      required: false,
      default: false
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
    index: {
      type: Number,
      required: true,
    },
    offered: {
      type: Boolean,
      reqiured: false,
      default: false
    }
  },
  methods: {
    selectSeat() {
      if (this.available) {
        // emit the event whether it's selected or not - we'll handle whether it is
        this.$emit("selectSeat", {
          seatInfo: this.seatInfo,
          index: this.index,
        });
      }
    },
  },
  computed: {
    altText() {
      if (!this.available) {
        return "Seat not available";
      } else {
        return this.selected ? "Seat selected" : "Seat available";
      }
    },
    isSelected() {
      if (!this.available) {
        return "taken";
      } else {
        return this.selected ? "selected" : "unselected";
      }
    },
    seatIcon() {
      // Used in SeatPreview loop; only true if passed in
      if(this.offered) {
        return ("/assets/seat-icons/SeatIcon_Offered_" + this.seatInfo.seatAngle + ".gif"); 
      } else if (!this.available) {
        return ("/assets/seat-icons/seat_taken--" + this.seatInfo.seatAngle + ".gif");
      } else {
        return ("/assets/seat-icons/seat_selected--" + this.seatInfo.seatAngle + ".gif");
      }
    },
    seatXCoord() {
      return this.seatInfo.topLeftCoordinates.split(",")[0];
    },
    seatYCoord() {
      return this.seatInfo.topLeftCoordinates.split(",")[1];
    },
    seatWidth() {
      let fullCoords = this.seatInfo.coordinates.split(",");
      let highestPoint = 0;
      fullCoords.forEach((item, index) => {
        item = parseInt(item)
        if (index % 2 == 0 && highestPoint < item) {
          highestPoint = item
        }
      })
      let width = highestPoint - this.seatXCoord;

      return width;
    },
    seatHeight() {
      let fullCoords = this.seatInfo.coordinates.split(",");
      let highestPoint = 0;
      fullCoords.forEach((item, index) => {
        item = parseInt(item)
        if (index % 2 == 1 && highestPoint < item) {
          highestPoint = item
        }
      })
      let height = highestPoint - this.seatYCoord;

      return height;
    },
    extraClasses() {
      if (!this.available) {
        return "seat--not-available";
      } else {
        return this.selected ? "seat--selected" : "seat--available";
      }
    },
  },
};
</script>